import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import classes from "./AllInvoices.module.scss";
import { Tooltip, ButtonToolbar, OverlayTrigger } from "react-bootstrap";
import ClientModal from "../components/profileComponents/ClientModal";
import { OrgIdContext } from "../store/orgId_context";
import { ReactComponent as EditBtn } from "../assets/enter.svg";
import { ReactComponent as CopyBtn } from "../assets/copy.svg";
import LoadingDots from "../components/UI/LoadingDots";
import useClients from "../hooks/useClients";
import { useCallback } from "react";
import { DDD, E2Data } from "../lib/ddd/ddd";
import { initRpcClient } from "../lib/ddd/RPCAxiosClient";
import ClientModal2 from "../components/profileComponents/ClientModal2";
import AddCustomer from "../components/clientsComponents/AddCustomer";
import Button from "../components/UI/Button";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ModalWindow from "../components/UI/ModalWindow";
import ClientsGridContainer from "../components/clientsComponents/ClientsGridContainer";
import { Hourglass } from "react-loader-spinner";
import CustomersGrid from "../components/table/CustomersGrid";
import { useTranslation } from 'react-i18next';
import { useLocation,useNavigate } from 'react-router-dom';
import { NotificationManager} from 'react-notifications';
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import CallSplitIcon from '@mui/icons-material/CallSplit';
import MergeIcon from '@mui/icons-material/Merge';
import InvoicesTable from "../components/table/InvoicesTable";
import { DateRangePicker } from 'react-date-range';
import { format, addDays, set  } from 'date-fns';
import { enUS,en, de, hr, it, pl, ro, nl, fr, es, ca } from 'date-fns/locale';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css'; // theme css
import ClearIcon from '@mui/icons-material/Clear';
import CodeIcon from '@mui/icons-material/Code';
import CircleIcon from '@mui/icons-material/Circle';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';

import { 
    Box, 
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem, 
    TextField, 
    Tabs, 
    Tab, 
    Typography, 
    List, 
    ListItem, 
    Link,
    ClickAwayListener,
    Popper,
    Paper,
    InputAdornment,
    IconButton,
    Slide,
    Collapse,
    Skeleton,
    Table, TableHead, TableRow, TableCell, TableBody,
    Tooltip as MuiTooltip,
    Checkbox,
    Menu,
    Divider,
    Switch
} from '@mui/material';
import {
    Receipt,         // Default invoice
    Description,     // Proforma
    EditNote,        // Corrective
    ReceiptLong,     // Construction-related
    Paid,            // Advance
    CreditScore,     // Credit note
    AttachMoney,     // Partial
    History,         // Self-invoice
    WarningAmber,    // Special cases
    ExpandMore, ExpandLess,
    Timeline, Person, Info,
  } from '@mui/icons-material';
import { useQuery } from "@tanstack/react-query";
import InvoiceDocsXmlViaUrl from "../components/integrationWizard/InvoiceDocsXmlViaUrl";
import { styled } from '@mui/system';
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import TimelineIcon from '@mui/icons-material/Timeline';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import NumbersIcon from '@mui/icons-material/Numbers';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { MenuContext } from "../store/menu_context";
import GenericModal from "../components/UI/GenericModal";
import OrganizationSettings from "./OrganizationSettings";
import InfoIcon from '@mui/icons-material/Info';
import ErrorIcon from '@mui/icons-material/Error';
import PersonIcon from '@mui/icons-material/Person';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { normalizeLocaleCode, reverseLocaleCode } from "../lib/normalizeLocaleCode";
import cultures from "../components/UI/cultures";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const CodeBlock = styled('pre')({
  backgroundColor: '#f5f5f5',
  padding: '1rem',
  borderRadius: '0.5rem',
  maxHeight: '300px',
  overflowY: 'auto',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  fontSize: '0.85rem',
});


const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ddd = new DDD(apiRequestAddress);

const entityInfo = new E2Data("EU_Invoices");
entityInfo.format="full";

const dateFnsLocales = {
    en: enUS,
    de,
    hr,
    it,
    pl,
    ro,
    nl,
    fr,
    es,
    // fallbacks
    si: enUS,
    rs: enUS,
    me: enUS,
    mk: enUS,
    ee: enUS,
    sk: enUS,
    cz: enUS,
};

/* const radioOptions1 = [
    { value: 'DateTimeCreate', label: 'Created' },
    { value: 'InvIssueDate', label: 'Issued' },
    { value: 'InvStartDate', label: 'Started' },
    { value: 'InvEndDate', label: 'Ended' },
];

const radioOptions2 = [
    { value: 'FiscMoment', label: 'Fiscalization' },
    { value: 'TAP_DeployDateTime', label: 'TAP' },
    { value: 'Peppol_RR_DateTime', label: 'Peppol' },
    { value: 'NET_DateTime', label: 'Net-other' },
    { value: 'eMail_SentTo_DateTime', label: 'eMail' },
]; */

const AllInvoices = ({iframeUrl="/mycompany", filter : staticFilter, isTest=false}) => {
    const { t, i18n  } = useTranslation();
    const locale = dateFnsLocales[i18n.language] || enUS;

    const { mainOrgId, sessionInfo, aboutOrgId } = useContext(OrgIdContext);
    //const [e2Data_scrTypes] = useState(new E2Data("EU_SCR_TypeCode").ApplyParams({format:"Full", filter: `Valid=true AND (CountryCodeSC__CountryCode='${sessionInfo?.Extended?.CountryCode}' OR CountryCodeSC__CountryCode='EU')`}))
    const [e2Data_scrTypes] = useState(new E2Data("EU_SCR_TypeCode").ApplyParams({format:"Full", filter: `Valid=true AND (CountryCodeSC='${sessionInfo?.Extended?.CountryCodeSC}' OR CountryCodeSC__CountryCode='EU')`, orderBy: "Order asc"}))
    const [e2Data_workflowSteps] = useState(new E2Data("EU_WorkflowSteps").ApplyParams({format:"Full"}))
    const [e2Data_userPreferences] = useState(new E2Data("CCITViews").ApplyParams({format:"Full", skip: 0, take : 1, filter: `SysUserMC='${sessionInfo?.User?.Id}'`}));
    const [e2Data_devices] = useState(new E2Data("VP_DevicesOrgUnits").ApplyParams({format:"Full", skip: 0, filter: `AssignedTo = 'CKT' AND OrgId='${aboutOrgId}'`}));
    const [customerChangeType, setCustomerChangeType] = useState();
    const [activeButton, setActiveButton] = useState(1);
    const [filter, setFilter] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();
    const currentLanguage = normalizeLocaleCode(i18n.language); 


    const [state, setState] = useState("null"); // Invoice State
    const [type, setType] = useState("null"); // Invoice Type
    const [device, setDevice] = useState("null"); // Invoice Type
    const [scrData, setScrData] = useState([]); // SCR Data
    const [stepsData, setStepsData] = useState([]); // Workflow Steps Data
    const [deviceData, setDeviceData] = useState([]); // Devices Data
    const [search, setSearch] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [tabValue, setTabValue] = useState("preview"); // Tab value for iframe
    const [fromDate, setFromDate] = React.useState(null);
    const [toDate, setToDate] = React.useState(null);
    const [mode, setMode] = useState(process.env.REACT_APP_API_ENDPOINT ? undefined : isTest ? "TEST" : "PROD"); //TEST
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [range, setRange] = useState([
        {
        startDate: null,
        endDate: null,
        key: 'selection',
        },
    ]);
    const [range2, setRange2] = useState([
        {
        startDate: null,
        endDate: null,
        key: 'selection',
        },
    ]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [panelMinimized, setPanelMinimized] = useState(false);
    const [loading, setLoading] = useState(false);
    const [referenceDocs, setReferenceDocs] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [history, setHistory] = useState([]);
    const [selectedRowLoaded, setSelectedRowLoaded] = useState(false);
    const [showErrorRow, setShowErrorRow] = useState(false);
    const [rawContent, setRawContent] = useState("");
    const [copied, setCopied] = useState(false);
    const [preview, setPreview] = useState(undefined);
    const previewRef = useRef();
    const anchorRef = useRef(null);
    const anchorRef2 = useRef(null);
    const { isMenuCollapsed } = useContext(MenuContext);
    const pickerRef = useRef();
    const collapseRef = useRef();
    const [selectCounter, setSelectCounter] = useState(0);
    const [selectCounter2, setSelectCounter2] = useState(0);
    const [pickerElement, setPickerElement] = useState(null);
    const [pickerElement2, setPickerElement2] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const openZip = Boolean(anchorEl);
    const [showZipModal, setShowZipModal] = useState(false);
    const [tableModel, setTableModel] = useState(undefined);
    const [tableModelLoaded, setTableModelLoaded] = useState(false);
    const [userPreferences, setUserPreferences] = useState(undefined);
    const [cccitRow, setCccitRow] = useState(null);
    const tableRef = useRef(null);
    const [isRightPanelCollapsed, setIsRightPanelCollapsed] = useState(false);
    const [dateField, setDateField] = useState("InvIssueDate");
    const [dateField2, setDateField2] = useState("FiscMoment");
    const [popupData, setPopupData] = useState();
    const [showInvoicePopup, setShowInvoicePopup] = useState();
    const [showComment, setShowComment] = useState();
    const [comment, setComment] = useState();

    const radioOptions1 = [
        { value: 'DateTimeCreate', label: t('Created') },
        { value: 'InvIssueDate', label: t('Issued') },
        { value: 'InvStartDate', label: t('Started') },
        { value: 'InvEndDate', label: t('Ended') },
    ];

    const radioOptions2 = [
        { value: 'FiscMoment', label: t('Fiscalization') },
        { value: 'TAP_DeployDateTime', label: t('TAP') },
        { value: 'Peppol_RR_DateTime', label: t('Peppol') },
        { value: 'NET_DateTime', label: t('Net-other') },
        { value: 'eMail_SentTo_DateTime', label: t('eMail') },
    ];

    const {isPending : entityInfoPending, data : entityInfoData} = useQuery({
        queryKey: ['Data.GetEntityData', entityInfo.GetParamsObject()],
        queryFn: () => entityInfo.GetEntityInfo(),
        staleTime: Infinity,
        cacheTime: Infinity
    })

    const {isPending : scrTypesPending, data : scrTypesData} = useQuery({
            queryKey: ['Data.GetEntityData', e2Data_scrTypes.GetParamsObject()],
            queryFn: () => e2Data_scrTypes.GetData(),
            staleTime: Infinity
    })

    const {isPending : stepsPending, data : stepsE2Data} = useQuery({
            queryKey: ['Data.GetEntityData', e2Data_workflowSteps.GetParamsObject()],
            queryFn: () => e2Data_workflowSteps.GetData(),
            staleTime: Infinity
    })

    const {isPending : devicesPending, data : devicesE2Data} = useQuery({
            queryKey: ['Data.GetEntityData', e2Data_devices.GetParamsObject()],
            queryFn: () => e2Data_devices.GetData(),
            staleTime: Infinity
    })

    useEffect(() => {
        if(tableModelLoaded) return;
        e2Data_userPreferences.GetData().then((data) => {
            setTableModelLoaded(true);
            if(!data?.result?.data || data?.result?.data.length === 0) return;
            const userPreferences = data.result.data[0];
            setCccitRow(userPreferences);
            if(!userPreferences?.DashboardJson) return;
            try {
                const model = JSON.parse(userPreferences.DashboardJson);
                if(model.IssuedPreviewVisible === false)
                    setIsRightPanelCollapsed(true)
                if(model && typeof model === 'object' && !Array.isArray(model)){
                    setUserPreferences(model);
                    if(model.IssuedTableModel)
                    setTableModel(model.IssuedTableModel);
                }
            } catch (error) {
                console.error("Error parsing DashboardJson:", error);
                return;
            }
        });
    }, [tableModelLoaded]);

    const onSaveTableModel = (model) => {
        if(!tableModelLoaded) return NotificationManager.error(t("Table not loaded yet"), t("Error"), 5000);
        const data = userPreferences ? {...userPreferences} : {};
        data.IssuedTableModel = model;
        data.IssuedPreviewVisible = !isRightPanelCollapsed;
        
        const e2Data = new E2Data("CCITViews");

        if(!cccitRow){
            const tbdata = {
                SysUserMC : sessionInfo?.User?.Id,
                DashboardJson : JSON.stringify(data),
            }
            e2Data.values = tbdata;
            e2Data.Create().then(() => {
                setTableModel(model);
                NotificationManager.success(t("User preferences created successfully"), t("Success"), 5000);
            }).catch((error) => {
                console.error("Error creating user preferences:", error);
                NotificationManager.error(t("Error creating user preferences"), t("Error"), 5000);
            });
        }else{
            e2Data.filter = `SysUserMC='${sessionInfo?.User?.Id}'`;
            const tbdata = {
                DashboardJson : JSON.stringify(data),
            }
            e2Data.values = tbdata;
            e2Data.Modify().then(() => {
                setTableModel(model);
                NotificationManager.success(t("User preferences updated successfully"), t("Success"), 5000);
            }).catch((error) => {
                console.error("Error updating user preferences:", error);
                NotificationManager.error(t("Error updating user preferences"), t("Error"), 5000);
            });
        }
    }

    const onSaveCurrentPreferences = () => {
        handleCloseMenu();
        const settings = tableRef.current?.getColumnSettings();
        onSaveTableModel(settings);
    }

    const onDeleteUserPreferences = () => {
        handleCloseMenu();
        if(!userPreferences) return;
        const e2Data = new E2Data("CCITViews");
        e2Data.filter = `SysUserMC='${sessionInfo?.User?.Id}'`;
        e2Data.values = {DashboardJson : {...userPreferences, IssuedTableModel: null, IssuedPreviewVisible: null}};

        e2Data.Modify().then(() => {
            setTableModel(undefined);
            setUserPreferences({...userPreferences, DashboardJson: null});
            NotificationManager.success(t("User preferences deleted successfully"), t("Success"), 5000);
        }).catch((error) => {
            console.error("Error deleting user preferences:", error);
            NotificationManager.error(t("Error deleting user preferences"), t("Error"), 5000);
        });
    }

    useEffect(() => {
        if(!scrTypesData) return;
        const data = scrTypesData?.result?.data ?? [];
        setScrData(data.some(item => item.CountryCodeSC__CountryCode !== "EU") ? data.filter(item => item.CountryCodeSC__CountryCode !== "EU") : data);
    },[scrTypesData])

    useEffect(() => {
        if(!stepsE2Data) return;
        const data = stepsE2Data?.result?.data ?? [];
        setStepsData(data);
    }, [stepsE2Data])

    useEffect(() => {
        if(!devicesE2Data) return;
        const data = devicesE2Data?.result?.data ?? [];
        setDeviceData(data);
    }, [devicesE2Data])
    
    const handleSelect = (ranges) => {
        if (!ranges || !ranges.selection) return;
        const newRange = [ranges.selection];
        setRange(newRange);

        if(selectCounter === 0) return setSelectCounter(1);
        if(selectCounter === 1) {
            const newRange = [ranges.selection];
            setRange(newRange);
            setSelectCounter(0)
            return setOpen(false);
        }
        return setSelectCounter(0);
    }
    const handleSelect2 = (ranges) => {
        if (!ranges || !ranges.selection) return;
        const newRange = [ranges.selection];
        setRange2(newRange);

        if(selectCounter2 === 0) return setSelectCounter2(1);
        if(selectCounter2 === 1) {
            const newRange = [ranges.selection];
            setRange2(newRange);
            setSelectCounter2(0)
            return setOpen2(false);
        }
        return setSelectCounter2(0);
    }
    const clearDateRange = (e) => {
        setSelectCounter(0)
        e.preventDefault();
        e.stopPropagation();
        setRange([{ startDate: null, endDate: null, key: 'selection' }]);
    };
    const clearDateRange2 = (e) => {
        setSelectCounter2(0)
        e.preventDefault();
        e.stopPropagation();
        setRange2([{ startDate: null, endDate: null, key: 'selection' }]);
    };
    const formattedValue =range[0].startDate && range[0].endDate ? `${format(range[0].startDate, 'dd/MM/yyyy')} - ${format(range[0].endDate, 'dd/MM/yyyy')}` : '';
    const formattedValue2 =range2[0].startDate && range2[0].endDate ? `${format(range2[0].startDate, 'dd/MM/yyyy')} - ${format(range2[0].endDate, 'dd/MM/yyyy')}` : '';

    const handleStateChange = (event) => {
        setState(event.target.value||"null");
    };
    
    const handleTypeChange = (event) => {
        setType(event.target.value||"null");
    };

    const handleDeviceChange = (event) => {
        setDevice(event.target.value||"null");
    };
    
    const handleSearchChange = (event) => {
        const value = event.target.value;
        if (value.length <= 50) {
            setSearch(value);
        }
    };
    useEffect(() => {
        const timeout = setTimeout(() => {
            setDebouncedSearch(search.trim());
        }, 1000);

        return () => clearTimeout(timeout);
    }, [search]);
    
    const handleTabChange = (event, newValue) => {
        if(newValue === "preview"){
            if(selectedRow) setPreview(process.env.REACT_APP_ORIGIN ?  process.env.REACT_APP_ORIGIN+`/invoicevisual?id=${selectedRow?.Id}&editable=false&hidebuttons=true&printable=true` : `/invoicevisual?id=${selectedRow?.Id}&editable=false&hidebuttons=true&printable=true`);
            else setPreview(undefined);
        }
        setTabValue(newValue);
    };

    const onChangeMode = () =>{
        setMode(mode === "PROD" ? "TEST" : "PROD");
    }

    useEffect(() => {
        if(!selectedRow){
            setReferenceDocs([]);
            setAttachments([]);
            setHistory([]);
            return;
        }
        //setLoading(true);
        const currentRequestId = selectedRow.Id; // Store the current ID
        /* setHistory([]);
        setReferenceDocs([]);
        setAttachments([]); */
        const e2Data_history = new E2Data("9ddd7cb9-8e54-11ec-90f9-9536f254aa7f").ApplyParams({format:"Full", filter: `EU_InvoicesMC ='${selectedRow.Id}'`, orderBy: "SeqNo desc"});
        const e2Data_refDocs = new E2Data("e0a10467-2f6b-11ed-9101-86ede1819251").ApplyParams({format:"Full", filter: `EU_InvoicesMC ='${selectedRow.Id}'`});
        const e2Data_attachments = new E2Data("7b4647c2-8e54-11ec-90f9-9536f254aa7f").ApplyParams({format:"Full", filter: `EU_InvoicesMC ='${selectedRow.Id}'`});
        Promise.all([e2Data_history.GetData(), e2Data_refDocs.GetData(), e2Data_attachments.GetData(),])
            .then(([historyRes, refDocsRes, attachmentsRes]) => {
                if (currentRequestId === selectedRow.Id) {
                    /* console.log("History:", historyRes?.result?.data);
                    console.log("Reference Documents:", refDocsRes?.result?.data);
                    console.log("Attachments:", attachmentsRes?.result?.data); */
                    setHistory(historyRes?.result?.data || []);
                    setReferenceDocs(refDocsRes?.result?.data || []);
                    setAttachments(attachmentsRes?.result?.data || []);
                    setSelectedRowLoaded(selectedRow);
                    //setLoading(false);
                }
            }).catch((error) => {
                console.error("Error fetching data:", error);
                if (currentRequestId === selectedRow.Id) {
                    setLoading(false);
                }
            });
    },[selectedRow])

    const setPreviewRowFromSelectedRow = (row) => {
        if(!row.Id) return setPreview(undefined);
        if(tabValue === "preview"){
            if(!preview) return setPreview(process.env.REACT_APP_ORIGIN ?  process.env.REACT_APP_ORIGIN+`/invoicevisual?id=${row?.Id}&editable=false&hidebuttons=true&printable=true` : `/invoicevisual?id=${row?.Id}&editable=false&hidebuttons=true&printable=true`);
            const iframeWindow = previewRef?.current?.contentWindow;
            if (!iframeWindow) return setPreview(process.env.REACT_APP_ORIGIN ?  process.env.REACT_APP_ORIGIN+`/invoicevisual?id=${row?.Id}&editable=false&hidebuttons=true&printable=true` : `/invoicevisual?id=${row?.Id}&editable=false&hidebuttons=true&printable=true`);
            let ui_view = null;
            const cc = cultures.result.find(c => c.IsoRegionName2 === reverseLocaleCode(currentLanguage)) || cultures.result.find(c => c.IsoRegionName2 === "us");
            if(row?.InvObject_UI_View){
                try{
                    ui_view = JSON.parse(row?.InvObject_UI_View);
                }catch(e){
                    console.error("Error parsing JSON:", e);
                }
            }
            if(row.Culture && row.Culture !== cc?.Culture) ui_view = null;
            iframeWindow.postMessage({
                action: "load",
                id: row?.Id,
                data: ui_view,
                //culture: "en-US" // You can replace this with dynamic culture if needed
            }, "*");
        }
        else{
            //setPreview(`http://localhost:81?id=${row?.Id}&editable=false&hidebuttons=true`);
            setPreview(process.env.REACT_APP_ORIGIN ?  process.env.REACT_APP_ORIGIN+`/invoicevisual?id=${row?.Id}&editable=false&hidebuttons=true&printable=true` : `/invoicevisual?id=${row?.Id}&editable=false&hidebuttons=true&printable=true`);
        }
    }

    const onRowSelect = (row) => {
        setSelectedRow(row);
        setPreviewRowFromSelectedRow(row);
        if(!row.PDFOriginal && tabValue === "pdfo")
            setTabValue("preview");
        if(!row.PDFHybrid && tabValue === "pdfh")
            setTabValue("preview");
        if(!row.PDFPrimary && tabValue === "pdf")
            setTabValue("preview");
        if(!row.XMLPeppol && tabValue === "xmlp")
            setTabValue("preview");
        if(!row.XMLSpecific && tabValue === "xmls")
            setTabValue("preview");
        if(!row.TAP_PDFSigned && tabValue === "pdf_tap_signed")
            setTabValue("preview");
        if(!row.TAP_XMLSpecificSigned && tabValue === "pdf_tap_specific")
            setTabValue("preview");
    }

    let previewUrl = undefined;
    let previewPrefix = undefined;
    //console.log(preview);
    if (selectedRow) {
        //previewUrl = process.env.REACT_APP_ORIGIN ?  process.env.REACT_APP_ORIGIN+`/invoicevisual?id=${selectedRow?.Id}&editable=false&hidebuttons=true` : `/invoicevisual?id=${selectedRow?.Id}&editable=false&hidebuttons=true`;
        previewUrl = `http://localhost:81?id=${selectedRow?.Id}&editable=false&hidebuttons=true`;
        previewPrefix = process.env.REACT_APP_ORIGIN ?  process.env.REACT_APP_ORIGIN : window.location.origin;
    }
    const handleOpenNotePopup = (row) => {
        setShowErrorRow(row);
        setRawContent(row.Note);
    }
    const onCpyConnKeyClick = () => {
        navigator.clipboard.writeText(rawContent);

        setCopied(rawContent);
        setTimeout(() => {
            setCopied(false);
        }, 1500);
    }
    useEffect(() => {
        if (!pickerElement) return;

        const staticRangesContainer = pickerElement.querySelector('.rdrStaticRanges');
        const translations = {
            'Today': t('Today'),
            'Yesterday': t('Yesterday'),
            'This Week': t('This week'),
            'Last Week': t('Last week'),
            'This Month': t('This month'),
            'Last Month': t('Last month'),
        };
        if(staticRangesContainer) {
            const labels = staticRangesContainer.querySelectorAll('.rdrStaticRangeLabel');
            labels.forEach((labelEl) => {
                const originalText = labelEl.textContent?.trim();
                if (originalText && translations[originalText]) {
                    labelEl.textContent = translations[originalText];
                }
            });
        }

        if (staticRangesContainer && !staticRangesContainer.querySelector('.custom-radio-group')) {
            const radioWrapper = document.createElement('div');
            radioWrapper.className = 'custom-radio-group';
            //radioWrapper.style.marginTop = '1rem';
            radioWrapper.style.display = 'flex';
            radioWrapper.style.flexDirection = 'column';
            radioWrapper.style.padding = '8px 12px';
            //radioWrapper.style.borderTop = '1px solid #ccc';
            radioWrapper.style.fontFamily = 'sans-serif';
            radioWrapper.style.fontSize = '14px';
            radioWrapper.style.gap = '6px';

            const labelHeader = document.createElement('div');
            labelHeader.textContent = t('Invoice date of')+":";
            labelHeader.style.fontWeight = 'bold';
            labelHeader.style.marginBottom = '2px';
            radioWrapper.appendChild(labelHeader);

            radioOptions1.forEach(({ value, label }) => {
                const labelEl = document.createElement('label');
                labelEl.style.display = 'flex';
                //labelEl.style.padding = '0px 10px';
                labelEl.style.alignItems = 'center';
                labelEl.style.cursor = 'pointer';
                labelEl.style.gap = '8px';

                const input = document.createElement('input');
                input.type = 'radio';
                input.name = 'filterType';
                input.value = value;
                input.checked = value === dateField;

                // Attach change handler to sync with React state
                input.addEventListener('change', () => {
                    setDateField(value);
                });

                const text = document.createTextNode(label);
                labelEl.appendChild(input);
                labelEl.appendChild(text);

                radioWrapper.appendChild(labelEl);
            });
            staticRangesContainer.appendChild(radioWrapper);
        }

        const handleStaticRangeClick = (event) => {
            const staticRangeBtn = event.target.closest('.rdrStaticRange');
            if (!staticRangeBtn) return;

            const staticRangesContainer = staticRangeBtn.closest('.rdrStaticRanges');
            if (!staticRangesContainer) return;

            const allStaticRangeBtns = staticRangesContainer.querySelectorAll('.rdrStaticRange');
            const clickedIndex = Array.from(allStaticRangeBtns).indexOf(staticRangeBtn);
            
            setTimeout(() => {
                setSelectCounter(0)
                setOpen(false);
            }, 500)
            // Check if it's the first button (Today)
            if (clickedIndex === 0) {
              //console.log('First static range button clicked (Today)');
            }
        };
    
        const container = pickerElement;
        container.addEventListener('click', handleStaticRangeClick);
    
        return () => {
          container.removeEventListener('click', handleStaticRangeClick);
        };
    }, [open, pickerElement]);

    useEffect(() => {
        if (!pickerElement2) return;

        const staticRangesContainer = pickerElement2.querySelector('.rdrStaticRanges');
        const translations = {
            'Today': t('Today'),
            'Yesterday': t('Yesterday'),
            'This Week': t('This week'),
            'Last Week': t('Last week'),
            'This Month': t('This month'),
            'Last Month': t('Last month'),
        };
        if(staticRangesContainer) {
            const labels = staticRangesContainer.querySelectorAll('.rdrStaticRangeLabel');
            labels.forEach((labelEl) => {
                const originalText = labelEl.textContent?.trim();
                if (originalText && translations[originalText]) {
                    labelEl.textContent = translations[originalText];
                }
            });
        }

        if (staticRangesContainer && !staticRangesContainer.querySelector('.custom-radio-group')) {
            const radioWrapper = document.createElement('div');
            radioWrapper.className = 'custom-radio-group';
            //radioWrapper.style.marginTop = '1rem';
            radioWrapper.style.display = 'flex';
            radioWrapper.style.flexDirection = 'column';
            radioWrapper.style.padding = '8px 12px';
            //radioWrapper.style.borderTop = '1px solid #ccc';
            radioWrapper.style.fontFamily = 'sans-serif';
            radioWrapper.style.fontSize = '14px';
            radioWrapper.style.gap = '6px';

            const labelHeader = document.createElement('div');
            labelHeader.textContent = t('Invoice date of')+":";
            labelHeader.style.fontWeight = 'bold';
            labelHeader.style.marginBottom = '2px';
            radioWrapper.appendChild(labelHeader);

            radioOptions2.forEach(({ value, label }) => {
                const labelEl = document.createElement('label');
                labelEl.style.display = 'flex';
                //labelEl.style.padding = '0px 10px';
                labelEl.style.alignItems = 'center';
                labelEl.style.cursor = 'pointer';
                labelEl.style.gap = '8px';

                const input = document.createElement('input');
                input.type = 'radio';
                input.name = 'filterType';
                input.value = value;
                input.checked = value === dateField2;

                // Attach change handler to sync with React state
                input.addEventListener('change', () => {
                    setDateField2(value);
                });

                const text = document.createTextNode(label);
                labelEl.appendChild(input);
                labelEl.appendChild(text);

                radioWrapper.appendChild(labelEl);
            });
            staticRangesContainer.appendChild(radioWrapper);
        }

        const handleStaticRangeClick = (event) => {
            const staticRangeBtn = event.target.closest('.rdrStaticRange');
            if (!staticRangeBtn) return;

            const staticRangesContainer = staticRangeBtn.closest('.rdrStaticRanges');
            if (!staticRangesContainer) return;

            const allStaticRangeBtns = staticRangesContainer.querySelectorAll('.rdrStaticRange');
            const clickedIndex = Array.from(allStaticRangeBtns).indexOf(staticRangeBtn);
            
            setTimeout(() => {
                setSelectCounter2(0)
                setOpen2(false);
            }, 500)

            if (clickedIndex === 0) {
              //console.log('First static range button clicked (Today)');
            }
        };
    
        const container = pickerElement2;
        container.addEventListener('click', handleStaticRangeClick);
    
        return () => {
          container.removeEventListener('click', handleStaticRangeClick);
        };
    }, [open2, pickerElement2]);
    

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleExportZip = () => {
        setShowZipModal(true);
        handleCloseMenu();
    };
     useEffect(() => {
        if (!panelMinimized) {
            const timer = setTimeout(() => {
                if (collapseRef.current) {
                collapseRef.current.style.height = '100%';
                }
            }, 350);
            return () => clearTimeout(timer);
        }
    }, [panelMinimized]);

    const formatDateTime = (dateStr) => {
        try {
            const date = new Date(dateStr);
            
            return date.toLocaleString(normalizeLocaleCode(i18n.language), {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false // Forces 24-hour format (e.g., "14:30" instead of "2:30 PM")
            });
        } catch {
            return '-';
        }
    };

    const parseActionString = (input) => {
        const match = input.match(/^([^\s-]+)\s*-\s*(.+)$/);
        if (match) {
            return {
            number: match[1],
            text: match[2].trim(),
            };
        }
        return { number: null, text: null };
    }

    const handleToggle = () => {
        setIsRightPanelCollapsed(!isRightPanelCollapsed);
        if(!selectedRow?.Id) return setPreview(undefined);
        setPreview(process.env.REACT_APP_ORIGIN ?  process.env.REACT_APP_ORIGIN+`/invoicevisual?id=${selectedRow?.Id}&editable=false&hidebuttons=true&printable=true` : `/invoicevisual?id=${selectedRow?.Id}&editable=false&hidebuttons=true&printable=true`);
    };

    const onRightClick = (data, event) =>{
        if(!data) return;
        if(event?.column?.colId === "InvStatusSC__TAP_Status"){
            setShowComment(true);
            setComment(data?.TAP_Comment)
        }else{
            setPopupData(data);
            setShowInvoicePopup(true);
        }
    }

    const getLabelFromValue = (value) => {
        if(!formattedValue) return null;
        const option = radioOptions1.find(option => option.value === value);
        return option ? t("Searching")+": "+option.label : null;
    };

    const getLabelFromValue2 = (value) => {
        if(!formattedValue2) return null;
        const option = radioOptions2.find(option => option.value === value);
        return option ? t("Searching")+": "+option.label : null;
    };

    return (
    <>
      <Helmet>
        <title>Invoices | DDD Invoices</title>
      </Helmet>
      <Dialog
        sx={{ '& .MuiDialog-paper': { width: '90%', maxHeight: 600 } }}
        maxWidth="xs"
        TransitionProps={{ }}
        onClose={() => setShowErrorRow(false)}
        open={showErrorRow}>
          <DialogTitle>
                {t("Error report")}
                <span className={classes["copyBtn"]} onClick={onCpyConnKeyClick}>
                    <CopyBtn className="ms-2" />
                    {copied && <span className="fs-6 align-middle">{t("Copied!")}</span>}
                </span>
            </DialogTitle>
          <DialogContent dividers>
            <CodeBlock>{rawContent}</CodeBlock>
          </DialogContent>
          <DialogActions>
            <Button className="ps-2 pe-2" autoFocus onClick={() => setShowErrorRow(false)}>
              {t("Close")}
            </Button>
          </DialogActions>
      </Dialog>
      <Dialog
        sx={{ '& .MuiDialog-paper': { width: '90%', maxHeight: 600 } }}
        maxWidth="xs"
        TransitionProps={{ }}
        onClose={() => setShowComment(false)}
        open={showComment}>
          <DialogTitle>
                {t("Comment")}
            </DialogTitle>
          <DialogContent dividers>
            <CodeBlock>{comment}</CodeBlock>
          </DialogContent>
          <DialogActions>
            <Button className="ps-2 pe-2" autoFocus onClick={() => setShowComment(false)}>
              {t("Close")}
            </Button>
          </DialogActions>
      </Dialog>
      <Dialog
        sx={{ '& .MuiDialog-paper': {maxWidth: 'calc(100vw - 64px)',minWidth: '400px', maxHeight: 800 } }}
        maxWidth={false}    
        TransitionProps={{ }}
        onClose={() => setShowInvoicePopup(false)}
        open={showInvoicePopup}>
            {/* <DialogTitle>
                {t("Invoice identifiers")}
            </DialogTitle> */}
            <Box
                sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '16px 24px 0 24px', // match DialogTitle default
                }}
            >
                <DialogTitle sx={{ m: 0, p: 0 }}>{t("Invoice identifiers")}</DialogTitle>
                <Box sx={{ display: 'flex', gap: 1 }}>
                {popupData?.PDFPrimary && (
                    <MuiTooltip title="Download PDF">
                    <IconButton
                        size="small"
                        color="primary"
                        onClick={() => {
                            const url = new URL(popupData?.PDFPrimary, window.location.origin);
                            url.searchParams.delete('inline');
                            const cleanedUrl = url.toString();
                            const link = document.createElement('a');
                            link.href = cleanedUrl;
                            link.download = popupData?.InvNum ? popupData?.InvNum+'.pdf' : popupData?.Id+'.pdf';
                            link.click();
                        }}
                    >
                        <PictureAsPdfIcon fontSize="small" />
                    </IconButton>
                    </MuiTooltip>
                )}
                {popupData?.PDFOriginal && (
                    <MuiTooltip title="Download PDF Original">
                    <IconButton
                        size="small"
                        color="primary"
                        onClick={() => {
                            const url = new URL(popupData?.PDFOriginal, window.location.origin);
                            url.searchParams.delete('inline');
                            const cleanedUrl = url.toString();
                            const link = document.createElement('a');
                            link.href = cleanedUrl;
                            link.download = popupData?.InvNum ? popupData?.InvNum+'_Original.pdf' : popupData?.Id+'.pdf';
                            link.click();
                        }}
                    >
                        <PictureAsPdfIcon fontSize="small" />
                    </IconButton>
                    </MuiTooltip>
                )}
                {popupData?.PDFHybrid && (
                    <MuiTooltip title="Download PDF Hybrid">
                    <IconButton
                        size="small"
                        color="primary"
                        onClick={() => {
                            const url = new URL(popupData?.PDFHybrid, window.location.origin);
                            url.searchParams.delete('inline');
                            const cleanedUrl = url.toString();
                            const link = document.createElement('a');
                            link.href = cleanedUrl;
                            link.download = popupData?.InvNum ? popupData?.InvNum+'_Hybrid.pdf' : popupData?.Id+'.pdf';
                            link.click();
                        }}
                    >
                        <PictureAsPdfIcon fontSize="small" />
                    </IconButton>
                    </MuiTooltip>
                )}
                {popupData?.TAP_PDFSigned && (
                    <MuiTooltip title="Download TAP Signed PDF">
                    <IconButton
                        size="small"
                        color="primary"
                        onClick={() => {
                            const url = new URL(popupData?.TAP_PDFSigned, window.location.origin);
                            url.searchParams.delete('inline');
                            const cleanedUrl = url.toString();
                            const link = document.createElement('a');
                            link.href = cleanedUrl;
                            link.download = popupData?.InvNum ? popupData?.InvNum+'_Hybrid.pdf' : popupData?.Id+'.pdf';
                            link.click();
                        }}
                    >
                        <PictureAsPdfIcon fontSize="small" />
                    </IconButton>
                    </MuiTooltip>
                )}
                {popupData?.TAP_XMLSpecificSigned && (
                    <MuiTooltip title="Download TAP Specific Signed XML">
                    <IconButton
                        size="small"
                        color="primary"
                        onClick={() => {
                            const url = new URL(popupData?.TAP_XMLSpecificSigned, window.location.origin);
                            url.searchParams.delete('inline');
                            const cleanedUrl = url.toString();
                            const link = document.createElement('a');
                            link.href = cleanedUrl;
                            link.download = popupData?.InvNum ? popupData?.InvNum+'_Hybrid.xml' : popupData?.Id+'.xml';
                            link.click();
                        }}
                    >
                        <CodeIcon fontSize="small" />
                    </IconButton>
                    </MuiTooltip>
                )}
                {popupData?.XMLPeppol && (
                    <MuiTooltip title="Download XML Peppol">
                    <IconButton
                        size="small"
                        color="primary"
                        onClick={() => {
                            const url = new URL(popupData?.XMLPeppol, window.location.origin);
                            url.searchParams.delete('inline');
                            const cleanedUrl = url.toString();
                            const link = document.createElement('a');
                            link.href = cleanedUrl;
                            link.download = popupData?.InvNum ? popupData?.InvNum+'_peppol.xml' : popupData?.Id+'.xml';
                            link.click();
                        }}
                    >
                        <CodeIcon fontSize="small" />
                    </IconButton>
                    </MuiTooltip>
                )}
                {popupData?.XMLSpecific && (
                    <MuiTooltip title="Download XML">
                    <IconButton
                        size="small"
                        color="primary"
                        onClick={() => {
                            const url = new URL(popupData?.XMLSpecific, window.location.origin);
                            url.searchParams.delete('inline');
                            const cleanedUrl = url.toString();
                            const link = document.createElement('a');
                            link.href = cleanedUrl;
                            link.download = popupData?.InvNum ? popupData?.InvNum+'.xml' : popupData?.Id+'.xml';
                            link.click();
                        }}
                    >
                        <CodeIcon fontSize="small" />
                    </IconButton>
                    </MuiTooltip>
                )}
                </Box>
            </Box>
          <DialogContent dividers>
            <Box
                component="div"
                sx={{
                    fontSize: '0.95rem',
                    maxWidth: 700,
                    bgcolor: '#f9f9f9',
                    borderRadius: 1,
                    p: 3,
                    //boxShadow: 1,
                }}
                >
                {/* Top section */}
                <Box
                    component="dl"
                    sx={{
                    display: 'grid',
                    gridTemplateColumns: '180px 1fr',
                    rowGap: 1.5,
                    columnGap: 6,
                    mb: 3,
                    color: 'text.primary',
                    '& dt': {
                        whiteSpace: 'nowrap',
                        fontWeight: 'bold',
                        alignSelf: 'center',
                    },
                    '& dd': {
                        margin: 0,
                        alignSelf: 'center',
                        borderBottom: '1px solid #ccc',
                        pb: 1,
                    },
                    }}
                >
                    <dt>{t("Invoice ID")}</dt>
                    {/* <dd>{popupData?.Id ?? ''}</dd> */}
                    <dd><PopupCopyContent data={popupData?.Id ?? ''}/></dd>

                    <dt>{t("Invoice Number")}</dt>
                    {/* <dd>{popupData?.InvNum ?? ''}</dd> */}
                    <dd><PopupCopyContent data={popupData?.InvNum ?? ''}/></dd>

                    <dt>{t("Device ID")}</dt>
                    <dd><PopupCopyContent data={popupData?.DeviceId ? `${popupData?.DeviceId}  (${popupData?.DeviceId__AssignedTo})` : ''}/></dd>
                </Box>

  
            <Box sx={{ mb: 2, textAlign:"center", borderBottom: '1px solid var(--main-blue)'}}>
                <strong
                style={{
                    fontSize: '1.25rem',
                    color: 'var(--main-blue)',
                    //borderBottom: '2px solid var(--main-blue)',
                    paddingBottom: '4px',
                    display: 'inline-block',
                }}
                >
                {t("Proof data subset")}
                </strong>
            </Box> 
            <Box
                component="dl"
                sx={{
                display: 'grid',
                gridTemplateColumns: '180px 1fr',
                rowGap: 1.5,
                columnGap: 6,
                color: 'text.primary',
                '& dt': {
                    whiteSpace: 'nowrap',
                    fontWeight: 'bold',
                    alignSelf: 'center',
                },
                '& dd': {
                    margin: 0,
                    alignSelf: 'center',
                    borderBottom: '1px solid #ddd',
                    pb: 1,
                },
                }}
            >
                <dt>{t("Fisc Operator Reg. Code")}</dt>
                {/* <dd>{popupData?.FiscOperatorRegCode ?? ''}</dd> */}
                <dd><PopupCopyContent data={popupData?.FiscOperatorRegCode ?? ''}/></dd>

                <dt>{t("Fiscal Tax Authority Number")}</dt>
                <dd><PopupCopyContent data={popupData?.FiscTANum ?? ''}/></dd>

                <dt>{t("TAP Inv Id")}</dt>
                <dd><PopupCopyContent data={popupData?.TAP_UniqueInvId ?? ''}/></dd>

                <dt>{t("TAP Seller Id")}</dt>
                <dd><PopupCopyContent data={popupData?.TAP_SellerInvId ?? ''}/></dd>

                <dt>{t("Peppol Receiver")}</dt>
                <dd><PopupCopyContent data={popupData?.Peppol_RR_ReceiverEA ?? ''}/></dd>

                <dt>{t("NET Id")}</dt>
                <dd><PopupCopyContent data={popupData?.NET_UniqueInvId ?? ''}/></dd>

                <dt>{t("eMail Sent")}</dt>
                <dd><PopupCopyContent data={popupData?.eMail_SentTo ?? ''}/></dd>
            </Box>
        </Box>

          </DialogContent>
          <DialogActions>
            <Button className="ps-2 pe-2" autoFocus onClick={() => setShowInvoicePopup(false)}>
              {t("Close")}
            </Button>
          </DialogActions>
      </Dialog>
        <GenericModal className="bs-modal-80" show={showZipModal} title={t("Document Exporter")} onHide={() => {setShowZipModal(false);}}  bodyStyle={{maxHeight:"85vh", minHeight:"40vh", padding:"0px"}}>   
            <OrganizationSettings modal={true}/>
        </GenericModal>
        <div className={`w-100 h-100 p-3 ${classes.container}`} style={isMenuCollapsed ? {maxWidth:"calc(100vw - 80px)"} : {maxWidth:"calc(100vw - 270px)"}}>
        <Box display="flex" flexWrap="wrap" gap={2} p={2} pb={1}>
        <FormControl
            variant="outlined"
            size="small"
            sx={{
                minWidth: 140,
                '& .MuiOutlinedInput-root': {
                    borderRadius: "1rem",
                    height: 36,
                    '& fieldset': { borderColor: 'var(--main-blue)' },
                    '&:hover fieldset': { borderColor: 'var(--main-blue)' },
                    '&.Mui-focused fieldset': { borderColor: 'var(--main-blue)' },
                }
            }}
            >
            <InputLabel>{t("Invoice State")}</InputLabel>
            <Select value={state ?? "null"} onChange={handleStateChange} label={t("Invoice State")}>
                {[
                    { value: "null", label: t("All"), color: "white" },
                    { value: "Warning", label: t("Warning"), color: "#b3d4fc" },
                    { value: "Error", label: t("Error"), color: "#f8b3b3" },
                    { value: "Pending", label: t("Pending"), color: "#ffe0b2" },
                    { value: "OK", label: "OK", color: "var(--main-blue)" },
                    { value: "Draft", label: t("Draft")+" (<35)", color: "#cde3e9" },
                ].map(({ value, label, color }) => (
                <MenuItem key={value} value={value}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{
                        width: 14,
                        height: 14,
                        borderRadius: 1,
                        backgroundColor: color,
                        border: '1px solid #ccc',
                    }} />
                    {label}
                    </Box>
                </MenuItem>
                ))}
            </Select>
            </FormControl>

            <FormControl 
                variant="outlined" 
                size="small"
                sx={{
                    minWidth: 140,
                    '& .MuiOutlinedInput-root': {
                        borderRadius: "1rem",
                        height: 36,
                        '& fieldset': { borderColor: 'var(--main-blue)' },
                        '&:hover fieldset': { borderColor: 'var(--main-blue)' },
                        '&.Mui-focused fieldset': { borderColor: 'var(--main-blue)' },
                    }
                }}>
                <InputLabel>{t("Invoice Type")}</InputLabel>
                <Select value={type ?? 'null'} onChange={handleTypeChange} label={t("Invoice Type")}>
                    <MenuItem value="null">{t("All")}</MenuItem>
                    {scrData?.map((item) => (
                        <MenuItem 
                            key={item.Code} 
                            value={item.Code}
                            sx={{
                            opacity: item.Valid === false ? 0.6 : 1,
                            color: item.Valid === false ? 'text.disabled' : 'text.primary',
                            }}
                        >
                            <Box sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 1,
                            filter: item.Valid === false ? 'grayscale(1)' : 'none'
                            }}>
                            {getInvoiceTypeIcon(item.Code)}
                            {item.Code}
                            </Box>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            {deviceData?.length > 1 && !isTest && <FormControl 
                variant="outlined" 
                size="small"
                sx={{
                    minWidth: 140,
                    '& .MuiOutlinedInput-root': {
                        borderRadius: "1rem",
                        height: 36,
                        '& fieldset': { borderColor: 'var(--main-blue)' },
                        '&:hover fieldset': { borderColor: 'var(--main-blue)' },
                        '&.Mui-focused fieldset': { borderColor: 'var(--main-blue)' },
                    }
                }}>
                <InputLabel>{t("Device")}</InputLabel>
                <Select value={device ?? 'null'} onChange={handleDeviceChange} label={t("Device")}
                renderValue={(selected) => {
                    if (selected === 'null') return t('All')
                    if (selected === 'other') return t('Other')
                    const item = deviceData?.find((d) => d.Id === selected)
                    return (
                        <span
                        title={item.Id}
                        style={{
                            display: 'inline-block',
                            maxWidth: 140, 
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            verticalAlign: 'middle',
                            alignItems: 'center',
                        }}
                    >
                        {item.Mode === "PROD" ? 
                            <CircleIcon style={{fontSize:"0.9rem", color:"green", marginRight:"0.2rem", flexShrink: 0, marginBottom:"3px"}}/>:
                            <PanoramaFishEyeIcon style={{fontSize:"0.9rem", color:"var(--main-blue)", marginRight:"0.2rem", flexShrink: 0, marginBottom:"3px"}}/>}
                        {item.ExternalName || item.InternalName || item.Id}
                    </span>
                    )
                    }}>
                    <MenuItem value="null">{t("All")}</MenuItem>
                    {deviceData?.map((item) => (
                        <MenuItem 
                            key={item.Id} 
                            value={item.Id}
                            sx={{
                            opacity: item.Valid === false ? 0.6 : 1,
                            color: item.Valid === false ? 'text.disabled' : 'text.primary',
                            }}
                        >
                            <Box sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 1,
                            filter: item.Valid === false ? 'grayscale(1)' : 'none'
                            }}>
                            {item.Mode === "PROD" ? 
                                <CircleIcon style={{fontSize:"0.9rem", color:"green", marginRight:"0.2rem"}}/> :
                                <PanoramaFishEyeIcon style={{fontSize:"0.9rem", color:"var(--main-blue)", marginRight:"0.2rem"}}/>}
                            <OverlayTrigger placement="top" overlay={<Tooltip style={{ zIndex: 2000 }}>{item.Id + " (" + t("Currently in ") + (item.Mode === "PROD" ? "production" : "test") + " mode)"}</Tooltip>}>
                                <span>{item.ExternalName || item.InternalName || item.Id}</span>
                            </OverlayTrigger>
                            </Box>
                        </MenuItem>
                    ))}
                    <MenuItem value="other">
                        <Box sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 1,
                            }}>
                                <HelpOutlineIcon sx={{ fontSize:"0.9rem", color:"var(--main-blue)", marginRight:"0.2rem" }} />
                        <OverlayTrigger placement="top" overlay={<Tooltip style={{ zIndex: 2000 }}>{t("Shows invoices that have not been assigned to any device")}</Tooltip>}>
                            <span>{t("Other")}</span>
                        </OverlayTrigger>
                        
                        </Box>
                    </MenuItem>
                </Select>
            </FormControl>}
            <ClickAwayListener onClickAway={() => setOpen(false)}>
                <Box sx={{ position: 'relative' }}>
                    <TextField
                    inputRef={anchorRef}
                    label={getLabelFromValue(dateField)||t("Select Date Range")}
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={formattedValue}
                    onClick={() => setOpen((prev) => !prev)}
                    readOnly
                    inputProps={{ autoComplete: 'off' }}
                    sx={{
                        minWidth: 140,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '1rem',
                          height: 36,
                          paddingRight: '0.5rem',
                          '& fieldset': {borderColor: 'var(--main-blue)',},
                          '&:hover fieldset': {borderColor: 'var(--main-blue)',},
                          '&.Mui-focused fieldset': {borderColor: 'var(--main-blue)',},
                          '& input': {
                            paddingTop: "15px",
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            textAlign: 'center', // optional if you want the text centered horizontally too
                          }
                        }
                      }}
                    InputProps={{
                        endAdornment: formattedValue && (
                        <InputAdornment position="end">
                            <IconButton onClick={clearDateRange}>
                            <ClearIcon />
                            </IconButton>
                        </InputAdornment>
                        ),
                    }}
                    InputLabelProps={{
                        sx: {
                        top: '1px',
                        fontSize: '0.85rem',
                        }
                    }}
                    />
                    <Popper open={open} anchorEl={anchorRef.current} placement="bottom-start"  sx={{ zIndex: 11 }}>
                        <Paper elevation={20} ref={(node) => setPickerElement(node)} >
                            <DateRangePicker
                                onChange={handleSelect}
                                showSelectionPreview={true}
                                moveRangeOnFirstSelection={false}
                                months={1}
                                zIndex={1000}
                                ranges={range}
                                direction="horizontal"
                                locale={locale}
                            />
                        </Paper>
                    </Popper>
                </Box>
            </ClickAwayListener>
            <ClickAwayListener onClickAway={() => setOpen2(false)}>
                <Box sx={{ position: 'relative' }}>
                    <TextField
                    inputRef={anchorRef2}
                    label={getLabelFromValue2(dateField2)||t("Select proof date range")}
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={formattedValue2}
                    onClick={() => setOpen2((prev) => !prev)}
                    readOnly
                    inputProps={{ autoComplete: 'off' }}
                    sx={{
                        minWidth: 140,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '1rem',
                          height: 36,
                          paddingRight: '0.5rem',
                          '& fieldset': {borderColor: 'var(--main-blue)',},
                          '&:hover fieldset': {borderColor: 'var(--main-blue)',},
                          '&.Mui-focused fieldset': {borderColor: 'var(--main-blue)',},
                          '& input': {
                            paddingTop: "15px",
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            textAlign: 'center', // optional if you want the text centered horizontally too
                          }
                        }
                      }}
                    InputProps={{
                        endAdornment: formattedValue2 && (
                        <InputAdornment position="end">
                            <IconButton onClick={clearDateRange2}>
                            <ClearIcon />
                            </IconButton>
                        </InputAdornment>
                        ),
                    }}
                    InputLabelProps={{
                        sx: {
                        top: '1px',
                        fontSize: '0.85rem',
                        }
                    }}
                    />
                    <Popper open={open2} anchorEl={anchorRef2.current} placement="bottom-start"  sx={{ zIndex: 11 }}>
                        <Paper elevation={20} ref={(node) => setPickerElement2(node)} >
                            <DateRangePicker
                                onChange={handleSelect2}
                                showSelectionPreview={true}
                                moveRangeOnFirstSelection={false}
                                months={1}
                                zIndex={1000}
                                ranges={range2}
                                direction="horizontal"
                                locale={locale}
                            />
                        </Paper>
                    </Popper>
                </Box>
            </ClickAwayListener>
            <TextField
                label={t("Search")}
                variant="outlined"
                size="small"
                sx={{
                    minWidth: 140,
                    '& .MuiOutlinedInput-root': {
                    borderRadius: '1rem',
                    padding: '0.5rem',
                    height: 36,
                    '& fieldset': {
                        borderColor: 'var(--main-blue)',
                    },
                    '&:hover fieldset': {
                        borderColor: 'var(--main-blue)',
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: 'var(--main-blue)',
                    }
                    },
                }}
                value={search}
                onChange={handleSearchChange}
                InputProps={{
                    maxLength: 36,
                    endAdornment: search ? (
                    <InputAdornment position="end">
                        <IconButton size="small" onClick={() => handleSearchChange({ target: { value: '' } })}>
                        <ClearIcon fontSize="small" />
                        </IconButton>
                    </InputAdornment>
                    ) : null,
                }}
                InputLabelProps={{
                        sx: {
                        top: '1px',
                        fontSize: '0.85rem',
                        }
                    }}
                />
                <Box sx={{ display: "flex", alignItems: "flex-end", gap: 1, ml: "auto" }}>
                    {mode === "TEST" && (
                    <Typography
                        variant="caption"
                        sx={{ color: "text.secondary", fontWeight: 500 }}
                    >
                        {t("Test")}
                    </Typography>
                    )}

                    <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{mode=== "PROD" ? t("Show test invoices (includes step < 35 OR unassigned mode)") : t("Show production invoices (includes step < 35 OR unassigned mode)")}</Tooltip>}
                    >
                    <Switch
                        checked={mode === "PROD"}
                        onChange={onChangeMode}
                        size="small"
                    />
                    </OverlayTrigger>

                    {mode === "PROD" && (
                    <Typography
                        variant="caption"
                        sx={{ color: "text.secondary", fontWeight: 500 }}
                    >
                        {t("Production")}
                    </Typography>
                    )}
                </Box>
            <MuiTooltip title={t("More options")}>
                <Box
                sx={{
                    backgroundColor: 'rgba(0, 123, 255, 0.05)', // fallback color close to main-blue w/ opacity
                    //backgroundColor: 'color-mix(in srgb, var(--main-blue) 15%, transparent)', // CSS color-mix for opacity
                    borderRadius: '50%',
                    p: 0.5,
                    //ml: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s',
                    '&:hover': {
                      backgroundColor: 'color-mix(in srgb, var(--main-blue) 10%, transparent)',
                    },
                }}
                >
                <IconButton size="small" onClick={handleOpenMenu}>
                    <MoreVertIcon style={{color:"var(--main-blue)"}}/>
                </IconButton>
                </Box>
            </MuiTooltip>
            <Menu anchorEl={anchorEl} open={openZip} onClose={handleCloseMenu}>
                <MenuItem onClick={handleExportZip}>{t("Open document exporter")}</MenuItem>
                <Divider />
                <MenuItem onClick={onSaveCurrentPreferences}>{t("Save current table layout")}</MenuItem>
                {tableModel  && <MenuItem onClick={onDeleteUserPreferences}>{t("Delete current table layout")}</MenuItem>}
            </Menu>
        </Box>
        <Box display="flex" height="calc(100vh - 150px)">
            <Box 
                display="flex" 
                flexDirection="column" 
                flex={isRightPanelCollapsed ? 1 : undefined}
                width={isRightPanelCollapsed ? '100%' : '50%'}
                minWidth={isRightPanelCollapsed ? undefined : '50%'}>
                <Box flex={panelMinimized || !selectedRow ? 1 : 0.6}>
                    {tableModelLoaded && <InvoicesTable
                        entityInfo={entityInfoData?.result?.tables?.[0]}
                        state={state}
                        suppressReactiveUpdates={true}
                        type={type}
                        device={device}
                        search={debouncedSearch}
                        range={range}
                        range2={range2}
                        filter={staticFilter}
                        onRowSelect={onRowSelect}
                        tableModel={tableModel}
                        dateField={dateField}
                        dateField2={dateField2}
                        stepsData={stepsData}
                        mode={mode}
                        ref={tableRef}
                        onRightClick={onRightClick}
                    />}
                </Box>
                <Slide direction="up" in={!!selectedRow} mountOnEnter unmountOnExit>
                <Box
                    flex={panelMinimized ? "0.07 1 0" : "0.4 1 0"}
                    //bgcolor="#f0f0f0"
                    //bgcolor="white"
                    //borderTop="1px solid #ccc"
                    overflow="auto"
                    transition="flex 0.3s"
                    display="flex"
                    flexDirection="column"
                    mt={1}
                >
                <Box display="flex" justifyContent="space-between" alignItems="center" px={2} py={0} border="1px solid #bdc3c7" bgcolor="#f5f7f7" sx={{
                    borderTopLeftRadius: '12px',
                    borderTopRightRadius: '12px',
                }}>
                    <Typography variant="body2">{t("Details for")} {selectedRowLoaded?.Id}{selectedRowLoaded?.InvNum && <span className="fw-bold ps-1">(InvNum: {selectedRowLoaded?.InvNum})</span>}</Typography>
                    <IconButton onClick={() => setPanelMinimized(!panelMinimized)}>
                        {panelMinimized ? <ExpandMore /> : <ExpandLess />}
                    </IconButton>
                </Box>

                <Collapse in={!panelMinimized} sx={{ 
                        height: '100%',
                        '& .MuiCollapse-wrapper': {
                            height: '100%',
                        },
                        '& .MuiCollapse-wrapperInner': {
                            height: '100%',
                        },
                        '& .MuiCollapse-root': {
                            height: '100%',
                        },
                        border : "1px solid #bdc3c7",
                        borderRadius: '0 0 12px 12px',
                        }} 
                        style={{height: '100%'}} ref = {collapseRef}> 

                    <Box px={2} py={1} display="flex" gap={0} flex={"1 1 0"} minHeight={0} height="100%" id="yolo2" bgcolor="white" sx={{
                        borderBottomLeftRadius: '12px',
                        borderBottomRightRadius: '12px',
                    }}>
                    {/* LEFT SIDE */}
                    <Box position="relative" flex={1} display="flex" flexDirection="column" gap={2} width="50%" minWidth="50%"  paddingRight={2} sx={{}} pt={1.5}>
                        <Box width="100%" display="flex" flex={1}>
                            {/* <Typography
                                variant="subtitle2"
                                fontWeight="bold"
                                sx={{
                                position: 'absolute',
                                top: '-8px',
                                left: '10px',
                                backgroundColor: 'white',
                                paddingX: 0.5,
                                color: 'rgba(0, 0, 0, 0.6)',
                                fontSize: '0.7rem',
                                zIndex: 10,
                                }}
                            >
                                Attachments
                            </Typography> */}
                            <Typography
                                variant="caption"
                                sx={{
                                position: 'absolute',
                                top: -4,
                                left: '50%',
                                transform: 'translateX(-50%)',
                                backgroundColor: '#fff',
                                px: 0.5,
                                fontSize: '0.8rem',
                                color: 'rgba(0, 0, 0, 0.6)',
                                zIndex: 1,
                                lineHeight: 1,
                                }}
                            >
                                {t("Attachments")}
                            </Typography>
                            <Box flex={1} overflow="auto" border="1px solid #ccc" borderRadius={1}>
                            <Table size="small" flex={1} sx={{
                                '& tbody td': {
                                fontSize: '12px',
                                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
                                lineHeight: 1.5,
                                fontWeight: 400,
                                padding: '6px 10px',
                                },
                            }}>
                            <TableHead sx={{ fontSize: '0.7rem', '& .MuiTypography-root': { fontSize: '0.7rem' }, '& .MuiSvgIcon-root': { fontSize: '1rem' }, '& .MuiTableCell-root': { paddingTop: '4px', paddingBottom: '4px' } }}>
                                <TableRow sx={{ backgroundColor: '#f5f7f7' }}>
                                    <TableCell sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '80%' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center',whiteSpace: 'nowrap' }}>
                                        <NumbersIcon fontSize="small" sx={{ mr: 1 }} />
                                        <span
                                        style={{
                                            color: 'rgba(0, 0, 0, 0.54)',
                                            fontSize: '12px',
                                            fontWeight: 600,
                                            fontFamily: 'var(--ag-font-family)',
                                        }}
                                        >
                                        {t("File Name")}
                                        </span>
                                    </Box>
                                    </TableCell>
                                    <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    
                                    <Box sx={{ display: 'flex', alignItems: 'center',whiteSpace: 'nowrap' }}>
                                        <OpenInNewIcon fontSize="small" sx={{ mr: 1 }} />
                                        <span
                                        style={{
                                            color: 'rgba(0, 0, 0, 0.54)',
                                            fontSize: '12px',
                                            fontWeight: 600,
                                            fontFamily: 'var(--ag-font-family)',
                                        }}
                                        >
                                        {t("View")}
                                        </span>
                                    </Box>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {attachments.map((file, idx) => {
                                const invNum = file?.EU_InvoicesMC__InvNum || '—';
                                const invFileName = file?.AttFileName || '—';
                                let link=null;
                                if(file.AttFileURL)
                                    link=process.env.REACT_APP_ORIGIN ? process.env.REACT_APP_ORIGIN+"/"+file.AttFileURL : "/"+file.AttFileURL

                                return (
                                    <TableRow key={idx}>
                                    <TableCell sx={{ whiteSpace: 'nowrap', overflow: 'hidden',textOverflow: 'ellipsis', fontSize: '12px',}}>{invFileName}</TableCell>
                                    <TableCell align="center" sx={{fontSize: '12px',}}>
                                        {link ? (
                                        <IconButton
                                            href={link}
                                            target="_blank"
                                            rel="noopener"
                                            size="small"
                                            title="Open"
                                        >
                                            <OpenInNewIcon fontSize="small" />
                                        </IconButton>
                                        ) : '—'}
                                    </TableCell>
                                    </TableRow>
                                );
                                })}
                            </TableBody>
                            </Table>
                            </Box>
                        </Box>
                    </Box>

                    {/* RIGHT SIDE – Invoice History */}
                    <Box position="relative" width="50%" maxWidth="50%" minWidth="50%" display="flex" flex={1} flexDirection="column" paddingRight={0} sx={{}} pt={1.5}>
                            {/* <Typography
                                variant="subtitle2"
                                fontWeight="bold"
                                sx={{
                                position: 'absolute',
                                    top: '-4px',
                                    left: '10px',
                                    //backgroundColor: '#f5f7f7',
                                    paddingX: 0.5,
                                    color: 'rgba(0, 0, 0, 0.6)',
                                    fontSize: '0.7rem',
                                    zIndex: 10,
                                    //background: `linear-gradient(to bottom, white 80%, #f5f7f7 80%)`,
                                }}
                            >
                                Invoice History
                            </Typography>  */}
                        <Typography
                            variant="caption"
                            sx={{
                            position: 'absolute',
                            top: -4,
                            left: '50%',
                            transform: 'translateX(-50%)',
                            backgroundColor: '#fff',
                            px: 0.5,
                            fontSize: '0.8rem',
                            color: 'rgba(0, 0, 0, 0.6)',
                            zIndex: 1,
                            lineHeight: 1,
                            }}
                        >
                            {t("Invoice History")}
                        </Typography>
                        <Box flex={1} overflow="auto" border="1px solid #ccc" borderRadius={1}>
                            <Table size="small" sx={{
                                '& tbody td': {
                                fontSize: '12px',
                                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
                                lineHeight: 1.5,
                                fontWeight: 400,
                                padding: '6px 10px',
                                },
                            }}>
                            <TableHead sx={{ position: 'sticky', top:0, fontSize: '0.7rem', '& .MuiTypography-root': { fontSize: '0.7rem' }, '& .MuiSvgIcon-root': { fontSize: '1rem' }, '& .MuiTableCell-root': {  paddingTop: '2px', paddingBottom: '2px' } }}>
                                <TableRow sx={{ backgroundColor: '#f5f7f7' }}>
                                <TableCell>
                                    {/* <Typography variant="subtitle2" fontWeight="bold" style={{ color: "rgba(0, 0, 0, 0.54)" }} sx={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                                        <Timeline fontSize="small" sx={{ mr: 1 }} />
                                        Stage
                                    </Typography> */}
                                    <Box sx={{ display: 'flex', alignItems: 'center',whiteSpace: 'nowrap' }}>
                                        <Timeline fontSize="small" sx={{ mr: 1 }} />
                                        <span
                                        style={{
                                            color: 'rgba(0, 0, 0, 0.54)',
                                            fontSize: '12px',
                                            fontWeight: 600,
                                            fontFamily: 'var(--ag-font-family)',
                                        }}
                                        >
                                        {t("Stage")}
                                        </span>
                                    </Box>
                                </TableCell>
                                <TableCell>
                                    {/* <Typography variant="subtitle2" fontWeight="bold" style={{ color: "rgba(0, 0, 0, 0.54)" }} sx={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                                        <Person fontSize="small" sx={{ mr: 1 }} />
                                        User
                                    </Typography> */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                                        <Person fontSize="small" sx={{ mr: 1 }} />
                                        <span
                                        style={{
                                            color: 'rgba(0, 0, 0, 0.54)',
                                            fontSize: '12px',
                                            fontWeight: 600,
                                            fontFamily: 'var(--ag-font-family)',
                                        }}
                                        >
                                        {t("User")}
                                        </span>
                                    </Box>
                                </TableCell>
                                <TableCell  sx={{ minWidth: 200 }}>
                                    {/* <Typography variant="subtitle2" fontWeight="bold" style={{ color: "rgba(0, 0, 0, 0.54)" }} sx={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                                        <Info fontSize="small" sx={{ mr: 1 }} />
                                        Info
                                    </Typography> */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                                        <Info fontSize="small" sx={{ mr: 1 }} />
                                        <span
                                        style={{
                                            color: 'rgba(0, 0, 0, 0.54)',
                                            fontSize: '12px',
                                            fontWeight: 600,
                                            fontFamily: 'var(--ag-font-family)',
                                        }}
                                        >
                                        {t("Info")}
                                        </span>
                                    </Box>
                                </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {history.map((row, idx) => (
                                <TableRow
                                    key={idx}
                                    sx={{
                                        backgroundColor: row.Error ? '#ffe6e6' : 'inherit',
                                        '&:hover': {
                                            backgroundColor: row.Error ? '#ffdddd' : '#fafafa',
                                        }
                                    }}
                                   /* sx={{
                                        backgroundColor:  'inherit',
                                        '&:hover': {
                                            backgroundColor: '#fafafa',
                                        }
                                    }} */
                                >
                                    <TableCell
                                    sx={{
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        fontSize: '12px',
                                    }}
                                    >
                                        {/* <MuiTooltip title={parseActionString(row.Action).text || t("Unknown")} placement="top">
                                            <Box
                                                sx={{
                                                    width: '1rem',
                                                    height: '1rem',
                                                    borderRadius: '50%',
                                                    backgroundColor: 'var(--main-blue)',
                                                    color: "white",
                                                    //border: '1px solid black',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    //fontWeight: 'bold',
                                                    fontSize: '0.6rem', // small enough to fit double digits
                                                    lineHeight: 1,
                                                }}
                                            >
                                                {parseActionString(row.Action).number || "?"}
                                            </Box>
                                        </MuiTooltip> */}
                                        <MuiTooltip title={parseActionString(row.Action).text || t("Unknown")} placement="top">
                                              <Box
                                                sx={{
                                                    width: '1rem',
                                                    height: '1rem',
                                                    borderRadius: '50%',
                                                    backgroundColor: 'var(--main-blue)',
                                                    color: "#fff",
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '0.6rem',
                                                    lineHeight: 1,
                                                    fontFamily: 'monospace',
                                                    verticalAlign: 'middle',
                                                    horizontalAlign: 'center',
                                                }}
                                                >
                                                {parseActionString(row.Action).number || "?"}
                                                </Box>
                                            </MuiTooltip>
                                        {row.Error ? (
                                            <MuiTooltip title={row.Note || 'Error'} placement="top">
                                                <ErrorIcon color="error" fontSize="small" style={{ marginLeft:"0.5rem"}}/>
                                            </MuiTooltip>
                                        ) : (
                                        <MuiTooltip title={row.Note || 'No note'} placement="top">
                                            <InfoIcon
                                                fontSize="small"
                                                sx={{ color: row.Note ? 'primary.main' : 'grey.400', marginLeft:"0.5rem" }}
                                            />
                                        </MuiTooltip>
                                        )}
                                        <MuiTooltip title={row.UserCreate || 'Unknown user'} placement="top">
                                            <Person fontSize="small" style={{ marginLeft:"0.5rem"}}/>
                                        </MuiTooltip>
                                        <MuiTooltip title={formatDateTime(row.DateTimeCreate)} placement="top">
                                            <AccessTimeIcon fontSize="small" style={{ marginLeft:"0.5rem", marginRight:"0.5rem"}}/>
                                        </MuiTooltip>
                                        {/* {row.Action} */}
                                        {parseActionString(row.Action).text || t("Unknown")}
                                    </TableCell>

                                    <TableCell
                                    sx={{
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        maxWidth: 200,
                                        fontSize: '12px',
                                    }}
                                    >
                                    {row.UserCreate}
                                    </TableCell>

                                    <TableCell
                                        sx={{
                                            fontSize: '12px',
                                            maxWidth: 300,
                                            /* display: '-webkit-box',
                                            WebkitLineClamp: 3,
                                            WebkitBoxOrient: 'vertical', */
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            cursor: row.Note?.length > 1 ? 'pointer' : 'default',
                                            '&:hover': {
                                                textDecoration: row.Note?.length > 1 ? 'underline' : 'none',
                                            },
                                        }}
                                        onClick={() => row.Note?.length > 1 && handleOpenNotePopup(row)}
                                    >
                                    {row.Note ? row.Note : <span style={{ color: 'transparent' }}>/</span>}
                                    </TableCell>
                                </TableRow>
                                ))}
                            </TableBody>
                            </Table>
                        </Box>
                    </Box>
                </Box>
                </Collapse>

                </Box>
            </Slide>
            </Box>
            <Box 
                width="4px" 
                bgcolor="grey.300" 
                position="relative"
                sx={{
                cursor: 'col-resize',
                '&:hover': {
                    bgcolor: 'grey.400',
                },
                }}
                onClick={handleToggle}
            >
                <IconButton
                size="small"
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'grey.300',
                    zIndex: 2,
                    p: 0.5,
                    '&:hover': {
                        bgcolor: 'grey.400',
                    },
                }}
                >
                {isRightPanelCollapsed ? <ChevronLeft fontSize="small" /> : <ChevronRight fontSize="small" />}
                </IconButton>
            </Box>
            {!isRightPanelCollapsed && 
            <Box pl={2} flex={1} minWidth="50%" display="flex" flexDirection="column" position="relative" sx={{ paddingTop:"1px"}}>
                <Tabs 
                    value={tabValue} 
                    onChange={handleTabChange}
                     sx={{
                        minHeight: 32,
                        height: 32,
                        backgroundColor: '#f5f7f7',
                        borderTopLeftRadius: 8,
                        borderTopRightRadius: 8,
                        color: 'rgba(0, 0, 0, 0.54)',
                        border: '1px solid #bdc3c7',
                        textTransform: 'none', // optional: disable uppercase
                        borderBottom: '1px solid rgb(189, 195, 199)',
                        '& .MuiTab-root': {
                            minHeight: 32,
                            height: 32,
                            padding: '4px 8px',
                            fontSize: '0.75rem',
                            textTransform: 'none',
                            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
                            color: 'rgba(0, 0, 0, 0.54)',
                            '&.Mui-selected': {
                                color: 'rgba(0, 0, 0, 0.54)',
                                fontWeight: 'bold'
                            },
                        },
                        '& .Mui-selected': {
                            color: 'rgba(0, 0, 0, 0.54)',
                        },
                        '& .MuiTabs-indicator': {
                            backgroundColor: 'rgba(0, 0, 0, 0.54)',
                        },
                        '& .MuiTab-wrapper': {
                            flexDirection: 'row',
                            gap: '4px',
                        },
                    }}>
                    <Tab value="preview" label={
                        <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            {/* <PictureAsPdfIcon /> */}
                            {t("Invoice Preview")}
                            <OpenInNewIcon
                            fontSize="small"
                            style={{ cursor: 'pointer' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                if(!selectedRow?.Id) return;
                                window.open(process.env.REACT_APP_ORIGIN ?  process.env.REACT_APP_ORIGIN+`/invoicevisual?id=${selectedRow?.Id}&editable=false&hidebuttons=true&printable=true` : `/invoicevisual?id=${selectedRow?.Id}&editable=false&hidebuttons=true&printable=true`, '_blank');
                            }}
                            />
                        </span>
                    } />
                    {selectedRow?.PDFPrimary && (
                        <Tab value="pdf" 
                            onClick={() => setTabValue("pdf")} 
                            label={<span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                PDF Primary
                                <OpenInNewIcon
                                fontSize="small"
                                style={{ cursor: 'pointer' }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if(!selectedRow.PDFPrimary) return;
                                    window.open(previewPrefix+"/"+selectedRow.PDFPrimary, '_blank');
                                }}
                            />
                        </span>} />
                    )}
                    {selectedRow?.PDFOriginal && (
                        <Tab value="pdfo" 
                            onClick={() => setTabValue("pdfo")}
                            label={<span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                PDF Original
                                <OpenInNewIcon
                                fontSize="small"
                                style={{ cursor: 'pointer' }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if(!selectedRow.PDFOriginal) return;
                                    window.open(previewPrefix+"/"+selectedRow.PDFOriginal, '_blank');
                                }}
                            />
                        </span>}/>
                    )}
                    {selectedRow?.PDFHybrid && (
                        <Tab value="pdfh" 
                            onClick={() => setTabValue("pdfh")}
                            label={<span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                PDF Hybrid
                                <OpenInNewIcon
                                fontSize="small"
                                style={{ cursor: 'pointer' }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if(!selectedRow.PDFHybrid) return;
                                    window.open(previewPrefix+"/"+selectedRow.PDFHybrid, '_blank');
                                }}
                            />
                        </span>}/>
                    )}
                    {selectedRow?.TAP_PDFSigned && (
                        <Tab value="pdf_tap_signed" 
                            onClick={() => setTabValue("pdf_tap_signed")}
                            label={<span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                TAP PDF Signed
                                <OpenInNewIcon
                                fontSize="small"
                                style={{ cursor: 'pointer' }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if(!selectedRow.TAP_PDFSigned) return;
                                    window.open(previewPrefix+"/"+selectedRow.TAP_PDFSigned, '_blank');
                                }}
                            />
                        </span>}/>
                    )}
                    {selectedRow?.TAP_XMLSpecificSigned && (
                        <Tab value="pdf_tap_specific" label="TAP XML Signed" onClick={() => setTabValue("pdf_tap_specific")} />
                    )}
                    {selectedRow?.XMLPeppol && (
                        <Tab value="xmlp" label="XMLP" onClick={() => setTabValue("xmlp")} />
                    )}
                    {selectedRow?.XMLSpecific && (
                        <Tab value="xmls" label="XMLS" onClick={() => setTabValue("xmls")} />
                    )}
                </Tabs>

                <Box flex={1} overflow="hidden" position="relative" sx={{backgroundColor: '#f5f7f7'}}>
                {tabValue === "preview" && (
                    <iframe
                    src={preview}
                    ref={previewRef}
                    width="100%"
                    height="100%"
                    title="t1"
                    />
                )}
                {tabValue === "pdf" && (
                    <iframe
                    src={selectedRow?.PDFPrimary ? previewPrefix+"/"+selectedRow.PDFPrimary : undefined}
                    width="100%"
                    height="100%"
                    title="t2"
                    />
                )}
                {tabValue === "pdfo" && (
                    <iframe
                    src={selectedRow?.PDFOriginal ? previewPrefix+"/"+selectedRow.PDFOriginal : undefined}
                    width="100%"
                    height="100%"
                    title="t2"
                    />
                )}
                {tabValue === "pdfh" && (
                    <iframe
                    src={selectedRow?.PDFHybrid ? previewPrefix+"/"+selectedRow.PDFHybrid : undefined}
                    width="100%"
                    height="100%"
                    title="t2"
                    />
                )}
                {tabValue === "pdf_tap_signed" && (
                    <iframe
                    src={selectedRow?.TAP_PDFSigned ? previewPrefix+"/"+selectedRow.TAP_PDFSigned : undefined}
                    width="100%"
                    height="100%"
                    title="t2"
                    />
                )}
                {tabValue === "pdf_tap_specific" && selectedRow?.TAP_XMLSpecificSigned && (
                    <Box
                        id="resultdiv"
                        className={classes["xml-div"]}
                        sx={{
                            display: 'flex',
                            flex: 1,
                            height: '100%',
                            overflow: 'auto',
                        }}
                  >
                    <InvoiceDocsXmlViaUrl minHeight={false} xml={previewPrefix + "/" + selectedRow.TAP_XMLSpecificSigned} />
                  </Box>
                )}
                {tabValue === "xmlp" && selectedRow?.XMLPeppol && 
                    <Box
                        id="resultdiv"
                        className={classes["xml-div"]}
                        sx={{
                            display: 'flex',
                            flex: 1,
                            height: '100%',
                            overflow: 'auto',
                        }}
                  >
                    <InvoiceDocsXmlViaUrl minHeight={false} xml={previewPrefix + "/" + selectedRow.XMLPeppol} />
                  </Box>
                }
                {tabValue === "xmls" && selectedRow?.XMLSpecific && 
                    <Box
                        id="resultdiv"
                        className={classes["xml-div"]}
                        sx={{
                            display: 'flex',
                            flex: 1,
                            height: '100%',
                            overflow: 'auto',
                        }}
                  >
                    <InvoiceDocsXmlViaUrl minHeight={false} xml={previewPrefix + "/" + selectedRow.XMLSpecific} />
                  </Box>
                }

                {!selectedRow && (
                    <Box
                    position="absolute"
                    top={0}
                    left={0}
                    width="100%"
                    height="100%"
                    bgcolor="rgba(255,255,255,0.6)"
                    backdropFilter="blur(4px)"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    zIndex={0}
                    borderRadius={1}
                    >
                    <Typography variant="h6" color="textSecondary" textAlign="center" px={2}>
                        {t("Please select a row from the table to view invoice details")}
                    </Typography>
                    </Box>
                )}
                </Box>
            </Box>}
        </Box>
      </div>
    </>
  );
};

export default AllInvoices;

const getInvoiceTypeIcon = (invoiceType) => {
    const iconStyle = { fontSize: '1rem', marginRight: '4px', color:"var(--main-blue)" };
  
    switch (invoiceType) {
      case 'INVOICECZ':
        return <Receipt style={{ ...iconStyle, color: '#1976d2' }} />; // Blue
      case 'INVOICESB':
        return <Receipt style={{ ...iconStyle, color: '#388e3c' }} />; // Green
      case 'PROFORMA':
        return <Description style={{ ...iconStyle, color: '#ffa000' }} />; // Amber
      case 'SELFINVOICE':
        return <History style={{ ...iconStyle, color: '#7b1fa2' }} />; // Purple
      case 'CORRECTIVE':
      case 'CORRECTIVECREDITNOTE':
        return <EditNote style={{ ...iconStyle, color: '#d32f2f' }} />; // Red
      case 'PARTIALINVOICE':
      case 'PARTIALFINALCONSTRINVOICE':
        return <AttachMoney style={{ ...iconStyle, color: '#0288d1' }} />; // Light blue
      case 'ADVANCE':
      case 'CORRECTIVEADVANCE':
        return <Paid style={{ ...iconStyle, color: '#689f38' }} />; // Light green
      case 'CREDITNOTE':
        return <CreditScore style={{ ...iconStyle, color: '#5c6bc0' }} />; // Indigo
      case 'FINALCONSTRINVOICE':
      case 'PARTIALCONSTRINVOICE':
        return <ReceiptLong style={{ ...iconStyle, color: '#5d4037' }} />; // Brown
      case 'INVOICE':
      default:
        return <Receipt style={iconStyle} />; // Default
    }
};

const PopupCopyContent = ({data}) => {
    const [color, setColor] = useState("var(--main-blue)");

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        _setColor("var(--main-orange)");
    };

    const _setColor = (color) => {
        setColor(color);
        setTimeout(() => {
            setColor("var(--main-blue)");
        }, 1000);
    };

    return (
    <Box display="flex" alignItems="center" gap="1rem" minHeight={"1rem"}>
        <span style={{
            flex: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            }}>{data ?? ''}</span>
        {data && <CopyBtn
            onClick={() => handleCopy(data ?? '')}
            style={{ cursor: 'pointer', fill: color }}
        />}
    </Box>)
}
